module.exports = __webpack_public_path__ + "static/media/userProfile.3f28b642.png";